import { useState, useCallback } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { getApiKey } from './lib/api';
import { AuthGate } from './components/AuthGate';
import { Layout } from './components/Layout';
import { AgentsPage } from './pages/Agents';
import { TestPage } from './pages/Test';
import { SessionsPage } from './pages/Sessions';
import { MeshPage } from './pages/Mesh';
import { SystemPage } from './pages/System';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 5_000,
    },
  },
});

export function App() {
  const [authed, setAuthed] = useState(() => !!getApiKey());

  const handleAuth = useCallback(() => {
    setAuthed(true);
  }, []);

  if (!authed) {
    return <AuthGate onAuth={handleAuth} />;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<AgentsPage />} />
            <Route path="test" element={<TestPage />} />
            <Route path="sessions" element={<SessionsPage />} />
            <Route path="mesh" element={<MeshPage />} />
            <Route path="system" element={<SystemPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
